module.exports = __webpack_public_path__ + "images/emoji/facepalm.2288768c1bed245ca680.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/emoji/facepalm.png
// module id = GeQ2
// module chunks = 24